import { CardContent, Error as ErrorComponent } from "@qw/ui";
import type { FC } from "react";

import { useDraft } from "../../providers/draft-provider";

export const DraftError: FC = () => {
  const { error } = useDraft();

  if (!error) {
    return null;
  }

  return (
    <CardContent>
      <ErrorComponent error={error} />
    </CardContent>
  );
};
